import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=e45c6928"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=e45c6928&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports